import { DestroyRef, inject, Injectable } from '@angular/core';
import { AuthEventManager } from '@iris/modules/auth/utils/auth.event-manager';
import { AuthFacade } from '@iris/modules/auth/utils/auth.facade';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, switchMap } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthAutoRefreshTokenService {
  private readonly authEventManager = inject(AuthEventManager);
  private readonly authFacade = inject(AuthFacade);
  private readonly destroyRef = inject(DestroyRef);

  activate(): void {
    this.handleTokenExpired();
    this.handlePageVisibility();
  }

  private handleTokenExpired(): void {
    this.authEventManager.authEvent$.pipe(
      filter((e) => e === 'TokenExpired'),
      switchMap(() => {
        // eslint-disable-next-line no-console
        console.info('[IRIS] Token auto refresh on expired');
        return this.authFacade.requestTokenRefresh();
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  private handlePageVisibility(): void {
    fromEvent(document, 'visibilitychange').pipe(
      filter(() => !document.hidden && this.authFacade.accessTokenExpired()),
      switchMap(() => {
        // eslint-disable-next-line no-console
        console.info('[IRIS] Token auto refresh on page awake');
        return this.authFacade.requestTokenRefresh();
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
